import CryptoTransactionProcessingModal from './crypto-transaction-processing-modal';

export default CryptoTransactionProcessingModal;
